import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=9e0144a6"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e0144a6')) {
      api.createRecord('9e0144a6', component.options)
    } else {
      api.reload('9e0144a6', component.options)
    }
    module.hot.accept("./HistoryList.vue?vue&type=template&id=9e0144a6", function () {
      api.rerender('9e0144a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/HistoryList.vue"
export default component.exports